import { Environment } from 'fym-common/src/config/types';
import { config } from '../../../config/config';

/**
 * Host that serves auto-generated track SmartLinks. Must stay in step with
 * `autoTrackHosts` in sml-preview's config and `AUTO_TRACK_LINK_HOST` in
 * musicapi's envs — those decide which host actually resolves.
 */
export function autoTrackLinkHost(): string {
  return config.environment === Environment.production ? 'link.music24.com' : 'link.musicpawa.com';
}

export function autoTrackLinkUrl(slug: string): string {
  return `https://${autoTrackLinkHost()}/${slug}`;
}
